import {Injectable} from "@angular/core";
import {Response} from "@angular/http";
import {Observable} from "rxjs";
import { map } from "rxjs/operators";
import {User} from "./user.model";
import {HttpClient} from "../../httpclient";



@Injectable()
export class UsersService {

    constructor(private httpClient: HttpClient) { }

    private basePath = '/uaa-service/';

    getAllUsers(): Observable<User[]> {
        return this.httpClient.get(this.basePath + 'users').pipe(map(this.extractData));
    }

    getUser(userId: number): Observable<User> {
        return this.httpClient.get(this.basePath + 'users/' + userId).pipe(map(this.extractData));
    }

    inactive(userId: number, version: number): Observable<Response> {
        return this.httpClient.post(this.basePath + 'users/' + userId + '/inactivation?version=' + version, null);
    }

    active(userId: number, version: number): Observable<Response> {
        return this.httpClient.post(this.basePath + 'users/' + userId + '/activation?version=' + version, null);
    }

    update(user: User): Observable<Response> {
        return this.httpClient.post(this.basePath + 'users', user);
    }

    save(user: User): Observable<Response> {
        return this.httpClient.post(this.basePath + 'users', user);
    }

    resetPassword(user: User): Observable<Response> {
        return this.httpClient.patch(this.basePath + 'users/' + user.id + '/password?version=' + user.version, user);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.response;
    }
}

